/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const bitsModals: { [k: string]: LazyModal } = {
  ExampleFullScreenModal: {
    loadComponent: () =>
      import(
        'bits/base/static-pages/modals/example-full-screen-modal/example-full-screen-modal.component'
      ).then(m => m.ExampleFullScreenModalComponent),
    loadModule: () =>
      import(
        'bits/base/static-pages/modals/example-full-screen-modal/example-full-screen-modal.module'
      ).then(m => m.ExampleFullScreenModalModule),
  },
  ExampleModal: {
    loadComponent: () =>
      import(
        'bits/base/static-pages/modals/example-modal/example-modal.component'
      ).then(m => m.ExampleModalComponent),
    loadModule: () =>
      import(
        'bits/base/static-pages/modals/example-modal/example-modal.module'
      ).then(m => m.ExampleModalModule),
  },
  ExampleSkillsModal: {
    loadComponent: () =>
      import(
        'bits/base/static-pages/modals/example-skills-modal/example-skills-modal.component'
      ).then(m => m.ExampleSkillsModalComponent),
    loadModule: () =>
      import(
        'bits/base/static-pages/modals/example-skills-modal/example-skills-modal.module'
      ).then(m => m.ExampleSkillsModalModule),
  },
  NewFileConfirmationModal: {
    loadComponent: () =>
      import(
        'bits/skits/components/confirmation-modal/new-file-confirmation-modal.component'
      ).then(m => m.NewFileConfirmationModalComponent),
    loadModule: () =>
      import(
        'bits/skits/components/confirmation-modal/new-file-confirmation-modal.module'
      ).then(m => m.NewFileConfirmationModalModule),
  },
};
